import { u as useTheme, T as ThemeManager } from '../../dist/useTheme-90e8e2c2.esm.js';
import 'react';

var AppTheme = {
  useTheme,
  ThemeManager
};

export { AppTheme as default };
